var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-page", attrs: { id: "page_Container" } },
    [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "main-container", attrs: { id: "main-container" } },
          [
            _c("div", { staticClass: "form-zone" }, [
              _c(
                "div",
                { staticClass: "form-zone-inner", attrs: { id: "forminput" } },
                [
                  _c(
                    "van-cell-group",
                    [
                      _c(
                        "van-field",
                        {
                          attrs: { type: "tel", placeholder: "请输入手机号码" },
                          model: {
                            value: _vm.ruleForm.phonenum,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "phonenum", $$v)
                            },
                            expression: "ruleForm.phonenum"
                          }
                        },
                        [
                          _c("template", { slot: "left-icon" }, [
                            _c("img", {
                              staticClass: "loginmobileimg",
                              attrs: { src: _vm.loginmobile, alt: "" }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "van-button",
                            {
                              staticClass: "send-btn",
                              class: { sended: !_vm.codeButton },
                              attrs: {
                                slot: "button",
                                size: "small",
                                type: "primary",
                                id: "btn",
                                disabled: !_vm.codeButton
                              },
                              on: { click: _vm.handleCode },
                              slot: "button"
                            },
                            [_vm._v(_vm._s(_vm.codeMsg))]
                          )
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "van-field",
                        {
                          attrs: {
                            maxlength: "4",
                            placeholder: "请输入验证码"
                          },
                          model: {
                            value: _vm.ruleForm.verificode,
                            callback: function($$v) {
                              _vm.$set(_vm.ruleForm, "verificode", $$v)
                            },
                            expression: "ruleForm.verificode"
                          }
                        },
                        [
                          _c("template", { slot: "left-icon" }, [
                            _c("img", {
                              attrs: { src: _vm.logincode, alt: "" }
                            })
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "login-btn" },
                [
                  _c(
                    "van-button",
                    {
                      attrs: {
                        size: "large",
                        type: "primary",
                        disabled: _vm.btndisabled,
                        round: ""
                      },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v("登录")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "gohome-bar", on: { click: _vm.gohome } },
              [
                _c("img", {
                  attrs: {
                    src: require("../assets/img/home/downtab/home1.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "word" }, [_vm._v("商城首页")])
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }